export default function calculateNextMonthDate(referenceDate) {
    if (!referenceDate) return null;
    const dateParts = referenceDate.split('-');

    const year = Number.parseInt(dateParts[0], 10);
    let month = Number.parseInt(dateParts[1], 10) - 1;

    const date = new Date(year, month);
    date.setMonth(date.getMonth() + 1);

    return date;
};
